export default __webpack_public_path__ + "static/media/ubuntu-regular.43f0e2df.ttf";